import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./loadingMessageCard.scss";
import ajiChatbotIcon from "../../../../../../../../../images/aji_image/ajiChatbotIcon.svg";

const LoadingMessageCard = () => (
  <div className="loadingMessageCard">
    <img src={ajiChatbotIcon} alt="" />
    <CircularProgress />
  </div>
);
export default LoadingMessageCard;
